import React from 'react';
import { List } from 'immutable';
import { InputForm } from './NoteInput.Form';
import { NoteHeader } from './NoteInput.Header';
import { CommentWithTags } from '../../CommentWithTags';
import { EDIT_NOTE_VIEW } from '../NoteInputContext';
import { getUserDomain } from '../../../../lib/utils';

// Show when no note has been created - A New note will  be created
export function EmptyNote({ context, hasPermission, onSubmit, showCheckMarkButtons }) {
  const { state, controller, textAreaRef, loggedUser, showAddNewNote } = context;
  if (hasPermission) {
    if (showAddNewNote) {
      return <NoteHeader icon="plus" label="Add a Note" onClick={() => controller.setView(EDIT_NOTE_VIEW)} />;
    }

    return (
      <InputForm
        onSubmit={onSubmit}
        state={state}
        controller={controller}
        textAreaRef={textAreaRef}
        loggedUser={loggedUser}
        showCheckMarkButtons={showCheckMarkButtons}
      />
    );
  }
}

// Show when a note already exist - can be edited if permission granted
export function ReadOnlyNote({ note, context, hasPermission, createdBy }) {
  const { controller, loggedUser } = context;
  const taggedParties = note?.get('taggedParties') || List();
  const noteHtmlText = note?.get('htmlText');
  const { isTrade } = getUserDomain(loggedUser);
  const noteByLabel = isTrade && note?.get('modifiedBy') ? 'Edited by You' : `By: ${createdBy}`;

  if (hasPermission) {
    return (
      <div className="d-flex flex-column w-100">
        <div className="d-flex justify-content-between my-3">
          <NoteHeader icon="pen" label="Edit" onClick={() => controller.setView(EDIT_NOTE_VIEW)} />
        </div>
        <span className="font-size-14 text-gray-400 d-inline-block">{noteByLabel}</span>
        <div>
          <CommentWithTags
            text={noteHtmlText}
            user={loggedUser}
            taggedParties={taggedParties?.toJS()}
            className="font-italic font-size-14"
            arialFont
          />
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column mt-2">
      <span className="font-weight-bold">Notes</span>
      <div>
        <span className="font-size-14 text-gray-400 d-inline-block mt-2">By: {createdBy}</span>
      </div>
      <div className="mt-1 ">
        <CommentWithTags
          className="font-italic font-size-14"
          text={noteHtmlText}
          user={loggedUser}
          taggedParties={taggedParties?.toJS()}
          arialFont
        />
      </div>
    </div>
  );
}

// Show when creating a new note or editing an existing note
export function EditingNote({ context, onSubmit, handleSetNote, showCheckMarkButtons }) {
  const { state, controller, textAreaRef, loggedUser } = context;
  return (
    <InputForm
      onSubmit={onSubmit}
      state={state}
      controller={controller}
      textAreaRef={textAreaRef}
      loggedUser={loggedUser}
      handleSetNote={handleSetNote}
      showCheckMarkButtons={showCheckMarkButtons}
    />
  );
}
